<div class="flex flex-col gap-3">
  <div class="rounded-xl border border-outline dark:border-outline-darkmode overflow-hidden">
    <table class="min-w-full">
      <thead>
        <tr>
          <th
            class="pl-6 pr-0.5 py-3.5 text-start bg-surface-variant-magic dark:bg-surface-variant-magic-darkmode rounded-tl-xl"
          >
            <ui-skeleton class="inline-block h-4 w-30 rounded-full" />
          </th>
          <th
            class="py-3.5 px-0.5 text-start bg-surface-variant-magic dark:bg-surface-variant-magic-darkmode"
          >
            <ui-skeleton class="inline-block h-4 w-30 rounded-full" />
          </th>
          <th
            class="py-3.5 px-0.5 text-end bg-surface-variant-magic dark:bg-surface-variant-magic-darkmode"
          >
            <ui-skeleton class="inline-block h-4 w-15 rounded-full" />
          </th>
          <th
            class="pr-6 pl-0.5 py-3.5 text-end bg-surface-variant-magic dark:bg-surface-variant-magic-darkmode rounded-tr-xl"
          >
            <ui-skeleton class="inline-block h-4 w-10 rounded-full" />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="text-sm font-semibold border-y border-outline dark:border-outline-darkmode text-on-surface-subtle dark:text-on-surface-subtle-darkmode bg-surface-variant-magic dark:bg-surface-variant-magic-darkmode"
        >
          <td colspan="4" class="px-6 py-2">
            <ui-skeleton class="inline-block h-3 w-30 rounded-full" />
          </td>
        </tr>
        <tr class="border-b border-outline dark:border-outline-darkmode">
          <td class="pl-6 pr-0.5 py-3.5 font-medium">
            <ui-skeleton class="inline-block h-3 w-30 rounded-full" />
          </td>
          <td class="py-3.5 px-0.5 flex flex-wrap gap-2">
            <ui-skeleton class="inline-block h-5 w-20 rounded-md" />
          </td>
          <td class="py-3.5 px-0.5 text-end">
            <ui-skeleton class="inline-block h-3 w-15 rounded-md" />
          </td>
          <td
            class="pr-6 pl-0.5 py-3.5 font-normal text-end overflow-hidden text-ellipsis whitespace-nowrap"
          >
            <ui-skeleton class="inline-block h-3 w-10 rounded-md" />
          </td>
        </tr>
        <tr class="border-b border-outline dark:border-outline-darkmode">
          <td class="pl-6 pr-0.5 py-3.5 font-medium">
            <ui-skeleton class="inline-block h-3 w-30 rounded-full" />
          </td>
          <td class="py-3.5 px-0.5 flex flex-wrap gap-2">
            <ui-skeleton class="inline-block h-5 w-20 rounded-md" />
          </td>
          <td class="py-3.5 px-0.5 text-end">
            <ui-skeleton class="inline-block h-3 w-15 rounded-md" />
          </td>
          <td
            class="pr-6 pl-0.5 py-3.5 font-normal text-end overflow-hidden text-ellipsis whitespace-nowrap"
          >
            <ui-skeleton class="inline-block h-3 w-10 rounded-md" />
          </td>
        </tr>
        <tr class="border-outline dark:border-outline-darkmode">
          <td class="pl-6 pr-0.5 py-3.5 font-medium">
            <ui-skeleton class="inline-block h-3 w-30 rounded-full" />
          </td>
          <td class="py-3.5 px-0.5 flex flex-wrap gap-2">
            <ui-skeleton class="inline-block h-5 w-20 rounded-md" />
          </td>
          <td class="py-3.5 px-0.5 text-end">
            <ui-skeleton class="inline-block h-3 w-15 rounded-md" />
          </td>
          <td
            class="pr-6 pl-0.5 py-3.5 font-normal text-end overflow-hidden text-ellipsis whitespace-nowrap"
          >
            <ui-skeleton class="inline-block h-3 w-10 rounded-md" />
          </td>
        </tr>
        <tr
          class="text-sm font-semibold border-y border-outline dark:border-outline-darkmode text-on-surface-subtle dark:text-on-surface-subtle-darkmode bg-surface-variant-magic dark:bg-surface-variant-magic-darkmode"
        >
          <td colspan="4" class="px-6 py-2">
            <ui-skeleton class="inline-block h-3 w-30 rounded-full" />
          </td>
        </tr>
        <tr class="border-b border-outline dark:border-outline-darkmode">
          <td class="pl-6 pr-0.5 py-3.5 font-medium">
            <ui-skeleton class="inline-block h-3 w-30 rounded-full" />
          </td>
          <td class="py-3.5 px-0.5 flex flex-wrap gap-2">
            <ui-skeleton class="inline-block h-5 w-20 rounded-md" />
          </td>
          <td class="py-3.5 px-0.5 text-end">
            <ui-skeleton class="inline-block h-3 w-15 rounded-md" />
          </td>
          <td
            class="pr-6 pl-0.5 py-3.5 font-normal text-end overflow-hidden text-ellipsis whitespace-nowrap"
          >
            <ui-skeleton class="inline-block h-3 w-10 rounded-md" />
          </td>
        </tr>
        <tr class="border-b border-outline dark:border-outline-darkmode">
          <td class="pl-6 pr-0.5 py-3.5 font-medium">
            <ui-skeleton class="inline-block h-3 w-30 rounded-full" />
          </td>
          <td class="py-3.5 px-0.5 flex flex-wrap gap-2">
            <ui-skeleton class="inline-block h-5 w-20 rounded-md" />
          </td>
          <td class="py-3.5 px-0.5 text-end">
            <ui-skeleton class="inline-block h-3 w-15 rounded-md" />
          </td>
          <td
            class="pr-6 pl-0.5 py-3.5 font-normal text-end overflow-hidden text-ellipsis whitespace-nowrap"
          >
            <ui-skeleton class="inline-block h-3 w-10 rounded-md" />
          </td>
        </tr>
        <tr class="border-outline dark:border-outline-darkmode">
          <td class="pl-6 pr-0.5 py-3.5 font-medium">
            <ui-skeleton class="inline-block h-3 w-30 rounded-full" />
          </td>
          <td class="py-3.5 px-0.5 flex flex-wrap gap-2">
            <ui-skeleton class="inline-block h-5 w-20 rounded-md" />
          </td>
          <td class="py-3.5 px-0.5 text-end">
            <ui-skeleton class="inline-block h-3 w-15 rounded-md" />
          </td>
          <td
            class="pr-6 pl-0.5 py-3.5 font-normal text-end overflow-hidden text-ellipsis whitespace-nowrap"
          >
            <ui-skeleton class="inline-block h-3 w-10 rounded-md" />
          </td>
        </tr>
        <tr
          class="text-sm font-semibold border-y border-outline dark:border-outline-darkmode text-on-surface-subtle dark:text-on-surface-subtle-darkmode bg-surface-variant-magic dark:bg-surface-variant-magic-darkmode"
        >
          <td colspan="4" class="px-6 py-2">
            <ui-skeleton class="inline-block h-3 w-30 rounded-full" />
          </td>
        </tr>
        <tr class="border-b border-outline dark:border-outline-darkmode">
          <td class="pl-6 pr-0.5 py-3.5 font-medium">
            <ui-skeleton class="inline-block h-3 w-30 rounded-full" />
          </td>
          <td class="py-3.5 px-0.5 flex flex-wrap gap-2">
            <ui-skeleton class="inline-block h-5 w-20 rounded-md" />
          </td>
          <td class="py-3.5 px-0.5 text-end">
            <ui-skeleton class="inline-block h-3 w-15 rounded-md" />
          </td>
          <td
            class="pr-6 pl-0.5 py-3.5 font-normal text-end overflow-hidden text-ellipsis whitespace-nowrap"
          >
            <ui-skeleton class="inline-block h-3 w-10 rounded-md" />
          </td>
        </tr>
        <tr class="border-b border-outline dark:border-outline-darkmode">
          <td class="pl-6 pr-0.5 py-3.5 font-medium">
            <ui-skeleton class="inline-block h-3 w-30 rounded-full" />
          </td>
          <td class="py-3.5 px-0.5 flex flex-wrap gap-2">
            <ui-skeleton class="inline-block h-5 w-20 rounded-md" />
          </td>
          <td class="py-3.5 px-0.5 text-end">
            <ui-skeleton class="inline-block h-3 w-15 rounded-md" />
          </td>
          <td
            class="pr-6 pl-0.5 py-3.5 font-normal text-end overflow-hidden text-ellipsis whitespace-nowrap"
          >
            <ui-skeleton class="inline-block h-3 w-10 rounded-md" />
          </td>
        </tr>
        <tr class="border-outline dark:border-outline-darkmode">
          <td class="pl-6 pr-0.5 py-3.5 font-medium">
            <ui-skeleton class="inline-block h-3 w-30 rounded-full" />
          </td>
          <td class="py-3.5 px-0.5 flex flex-wrap gap-2">
            <ui-skeleton class="inline-block h-5 w-20 rounded-md" />
          </td>
          <td class="py-3.5 px-0.5 text-end">
            <ui-skeleton class="inline-block h-3 w-15 rounded-md" />
          </td>
          <td
            class="pr-6 pl-0.5 py-3.5 font-normal text-end overflow-hidden text-ellipsis whitespace-nowrap"
          >
            <ui-skeleton class="inline-block h-3 w-10 rounded-md" />
          </td>
        </tr>
        <tr
          class="text-sm font-semibold border-y border-outline dark:border-outline-darkmode text-on-surface-subtle dark:text-on-surface-subtle-darkmode bg-surface-variant-magic dark:bg-surface-variant-magic-darkmode"
        >
          <td colspan="4" class="px-6 py-2">
            <ui-skeleton class="inline-block h-3 w-30 rounded-full" />
          </td>
        </tr>
        <tr class="border-b border-outline dark:border-outline-darkmode">
          <td class="pl-6 pr-0.5 py-3.5 font-medium">
            <ui-skeleton class="inline-block h-3 w-30 rounded-full" />
          </td>
          <td class="py-3.5 px-0.5 flex flex-wrap gap-2">
            <ui-skeleton class="inline-block h-5 w-20 rounded-md" />
          </td>
          <td class="py-3.5 px-0.5 text-end">
            <ui-skeleton class="inline-block h-3 w-15 rounded-md" />
          </td>
          <td
            class="pr-6 pl-0.5 py-3.5 font-normal text-end overflow-hidden text-ellipsis whitespace-nowrap"
          >
            <ui-skeleton class="inline-block h-3 w-10 rounded-md" />
          </td>
        </tr>
        <tr class="border-b border-outline dark:border-outline-darkmode">
          <td class="pl-6 pr-0.5 py-3.5 font-medium">
            <ui-skeleton class="inline-block h-3 w-30 rounded-full" />
          </td>
          <td class="py-3.5 px-0.5 flex flex-wrap gap-2">
            <ui-skeleton class="inline-block h-5 w-20 rounded-md" />
          </td>
          <td class="py-3.5 px-0.5 text-end">
            <ui-skeleton class="inline-block h-3 w-15 rounded-md" />
          </td>
          <td
            class="pr-6 pl-0.5 py-3.5 font-normal text-end overflow-hidden text-ellipsis whitespace-nowrap"
          >
            <ui-skeleton class="inline-block h-3 w-10 rounded-md" />
          </td>
        </tr>
        <tr class="border-outline dark:border-outline-darkmode">
          <td class="pl-6 pr-0.5 py-3.5 font-medium">
            <ui-skeleton class="inline-block h-3 w-30 rounded-full" />
          </td>
          <td class="py-3.5 px-0.5 flex flex-wrap gap-2">
            <ui-skeleton class="inline-block h-5 w-20 rounded-md" />
          </td>
          <td class="py-3.5 px-0.5 text-end">
            <ui-skeleton class="inline-block h-3 w-15 rounded-md" />
          </td>
          <td
            class="pr-6 pl-0.5 py-3.5 font-normal text-end overflow-hidden text-ellipsis whitespace-nowrap"
          >
            <ui-skeleton class="inline-block h-3 w-10 rounded-md" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="flex justify-end">
    <div class="block md:grid lg:block xl:grid grid-cols-12 gap-y-4">
      <span class="col-span-9 block py-1">
        <ui-skeleton class="block h-3 w-30 rounded-md" />
      </span>
      <span class="col-span-3 block py-1 text-end">
        <ui-skeleton class="block h-3 w-30 rounded-md" />
      </span>
      <span class="col-span-9 block py-1">
        <ui-skeleton class="block h-3 w-30 rounded-md" />
      </span>
      <span class="col-span-3 block py-1 text-end">
        <ui-skeleton class="block h-3 w-30 rounded-md" />
      </span>
    </div>
  </div>
</div>
